var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 83,
  height: 103,
  viewBox: "0 0 83 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_375)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.22 57.96C32.728 60.256 32.482 62.2787 32.482 64.028C32.482 65.668 32.81 66.98 33.466 67.964C34.1767 68.948 35.4613 69.44 37.32 69.44C38.7413 69.44 39.944 69.1667 40.928 68.62C41.912 68.0187 42.732 67.1987 43.388 66.16C44.044 65.1213 44.5633 63.9187 44.946 62.552C45.3833 61.1307 45.766 59.6 46.094 57.96C46.3127 56.8667 46.4767 55.8553 46.586 54.926C46.75 53.9967 46.832 53.1493 46.832 52.384C46.832 50.4707 46.422 49.104 45.602 48.284C44.8367 47.4093 43.634 46.972 41.994 46.972C39.6433 46.972 37.7847 47.8193 36.418 49.514C35.106 51.2087 34.04 54.024 33.22 57.96ZM50.44 32.704C50.5493 32.1573 50.6313 31.638 50.686 31.146C50.7407 30.654 50.768 30.1893 50.768 29.752C50.768 28.3853 50.44 27.374 49.784 26.718C49.128 26.0073 48.062 25.652 46.586 25.652C45.0007 25.652 43.6613 26.0347 42.568 26.8C41.4747 27.5107 40.5453 28.522 39.78 29.834C39.0147 31.146 38.3587 32.704 37.812 34.508C37.2653 36.312 36.7733 38.28 36.336 40.412L35.68 43.282H35.844C37.156 41.7513 38.8233 40.5487 40.846 39.674C42.8687 38.7447 45.192 38.28 47.816 38.28C51.8067 38.28 54.6493 39.346 56.344 41.478C58.0933 43.5553 58.968 46.3433 58.968 49.842C58.968 51.9193 58.722 54.106 58.23 56.402C56.8633 63.1807 54.3213 68.3467 50.604 71.9C46.9413 75.3987 41.8027 77.148 35.188 77.148C32.4 77.148 30.0767 76.7653 28.218 76C26.414 75.2893 24.9653 74.3053 23.872 73.048C22.7787 71.736 21.986 70.2053 21.494 68.456C21.0567 66.652 20.838 64.7113 20.838 62.634C20.838 60.7207 20.9747 58.698 21.248 56.566C21.576 54.434 21.986 52.2473 22.478 50.006C23.3527 45.906 24.3093 41.9427 25.348 38.116C26.3867 34.2347 27.8353 30.818 29.694 27.866C31.5527 24.8593 33.9853 22.454 36.992 20.65C39.9987 18.846 43.9073 17.944 48.718 17.944C50.522 17.944 52.244 18.1353 53.884 18.518C55.524 18.9007 56.9453 19.5293 58.148 20.404C59.4053 21.224 60.3893 22.3173 61.1 23.684C61.8107 25.0507 62.166 26.7453 62.166 28.768C62.166 29.8613 62.0293 31.1733 61.756 32.704H50.44Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_375",
  x: -4,
  y: 0.94397,
  width: 86.166,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_375"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_375",
  result: "effect2_dropShadow_1_375"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_375",
  result: "effect3_dropShadow_1_375"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_375",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_375",
  x: 16.8379,
  y: 17.944,
  width: 49.3281,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_375"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_375",
  result: "shape"
})))));
export default SvgRank6;